export const HISTORICAL_MODULE_TAB_TRANSLATION = {
    'HISTORICAL_MODULE.TAB.GENERAL': 'General'
};
